import React, { Dispatch, SetStateAction } from 'react';

import { PartnerInvoiceType } from '@portals/api/partners';
import { DetailsPanel } from '@portals/core';

import { useUploadReceipt } from '../../../../hooks/Receipt/receipt.hooks';

interface InvoicePanelActionsProps {
  invoice: PartnerInvoiceType;
  isItemsPanelOpen: boolean;
  setIsItemsPanelOpen: Dispatch<SetStateAction<boolean>>;
  isReceiptPanelOpen: boolean;
  setIsReceiptPanelOpen: Dispatch<SetStateAction<boolean>>;
}

export function InvoicePanelActions({
  invoice,
  isItemsPanelOpen,
  setIsItemsPanelOpen,
  isReceiptPanelOpen,
  setIsReceiptPanelOpen,
}: InvoicePanelActionsProps) {
  const uploadReceiptFile = useUploadReceipt(invoice?.id);

  if (invoice.status !== 'failed') {
    return (
      <DetailsPanel.Actions>
        {invoice?.invoice_file_url ? (
          <DetailsPanel.ActionButton
            onClick={() => setIsReceiptPanelOpen(!isReceiptPanelOpen)}
          >
            {isReceiptPanelOpen ? 'Hide Receipt' : 'Show Receipt'}
          </DetailsPanel.ActionButton>
        ) : (
          <DetailsPanel.ActionButton
            variant="filled"
            onClick={uploadReceiptFile}
          >
            Upload Receipt
          </DetailsPanel.ActionButton>
        )}

        <DetailsPanel.ActionButton
          onClick={() => setIsItemsPanelOpen(!isItemsPanelOpen)}
        >
          {isItemsPanelOpen ? 'Hide Items' : 'Show Items'}
        </DetailsPanel.ActionButton>
      </DetailsPanel.Actions>
    );
  }

  return (
    <DetailsPanel.Actions grow>
      <DetailsPanel.ActionButton
        onClick={() => setIsItemsPanelOpen(!isItemsPanelOpen)}
      >
        {isItemsPanelOpen ? 'Hide Items' : 'Show Items'}
      </DetailsPanel.ActionButton>

      <DetailsPanel.ActionButton
        onClick={() => window.open('mailto:support@xyte.io', '_blank')}
      >
        Contact support
      </DetailsPanel.ActionButton>
    </DetailsPanel.Actions>
  );
}
